<form #form="ngForm">
    <div *ngIf="(passwordParamsService.getCurrent() | async) as passwordParams; else loading">
        <!--Type Authentification-->
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.authentification.generalites.authentification'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <!--Type Authentification-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="passwordParams.loginType"
                            [selectOptions]="listeLoginType"
                            libelle="admin.parametres.authentification.generalites.typeAuthentification"
                            name="loginType"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                    <!--Activation reCAPTCHA-->
                    <custom-input
                            ngDefaultControl
                            customType="checkbox"
                            name="recaptchaActif"
                            [ngModel]="passwordParams.recaptchaActif"
                            [(customModel)]="passwordParams.recaptchaActif"
                            libelle="admin.parametres.authentification.generalites.recaptchaActif"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>

        <!--Stratégie de mot de passe local-->
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.authentification.generalites.strategie'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <div class="col-md-10 offset-1">
                        <p>
                            <span translate>admin.parametres.authentification.generalites.info1</span><br>
                            <span translate>admin.parametres.authentification.generalites.info2</span><br>
                            <span translate>admin.parametres.authentification.generalites.info3</span>
                        </p>
                        <p translate>admin.parametres.authentification.generalites.info4</p><br>
                    </div>
                </div>
                <div class="row">
                    <!--Durée de vie-->
                    <custom-input
                            ngDefaultControl
                            id="peremptionNbJour"
                            name="peremptionNbJour"
                            [(ngModel)]="passwordParams.peremptionNbJour"
                            customType="number"
                            [required]="true"
                            min="30"
                            max="90"
                            libelle="admin.parametres.authentification.generalites.dureeDeVie"
                            [suffix]="'admin.parametres.authentification.generalites.dureeDeVieSuffixe' | translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.dureeDeVieTooltip' | translate"
                    ></custom-input>
                    <!--Vérrouillage-->
                    <custom-input
                            customType="number"
                            ngDefaultControl
                            name="nbTentatives"
                            [(ngModel)]="passwordParams.tentativeNb"
                            libelle="admin.parametres.authentification.generalites.verrouillage"
                            [suffix]="'admin.parametres.authentification.generalites.verrouillageSuffixe' | translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.verrouillageTooltip' | translate"
                            [required]="true"
                            min="3"
                            max="5"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Historique-->
                    <custom-input
                            ngDefaultControl
                            id="historique"
                            name="historique"
                            [(ngModel)]="passwordParams.historique"
                            customType="number"
                            [required]="true"
                            min="3"
                            max="5"
                            libelle="admin.parametres.authentification.generalites.historique"
                            [suffix]="'admin.parametres.authentification.generalites.historiqueSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.historiqueTooltip' | translate"
                    ></custom-input>
                    <!--Longueur minimal-->
                    <custom-input
                            ngDefaultControl
                            id="longueurMin"
                            name="longueurMin"
                            [(ngModel)]="passwordParams.minLength"
                            customType="number"
                            [required]="true"
                            min="12"
                            libelle="admin.parametres.authentification.generalites.longueurMinimal"
                            [suffix]="'admin.parametres.authentification.generalites.longueurMinimalSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.longueurMinimalTooltip' | translate"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Nombre de majuscules-->
                    <custom-input
                            ngDefaultControl
                            id="minMajuscule"
                            name="minMajuscule"
                            [(ngModel)]="passwordParams.minMajuscule"
                            customType="number"
                            [required]="true"
                            min="1"
                            libelle="admin.parametres.authentification.generalites.nombreMajuscules"
                            [suffix]="'admin.parametres.authentification.generalites.nombreMajusculesSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.nombreMajusculesTooltip' | translate"
                    ></custom-input>
                    <!--Nombre de chiffres-->
                    <custom-input
                            ngDefaultControl
                            id="minChiffre"
                            name="minChiffre"
                            [(ngModel)]="passwordParams.minChiffre"
                            customType="number"
                            [required]="true"
                            min="1"
                            libelle="admin.parametres.authentification.generalites.nombreChiffre"
                            [suffix]="'admin.parametres.authentification.generalites.nombreChiffreSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.nombreChiffreTooltip' | translate"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Nombre de minuscules-->
                    <custom-input
                            ngDefaultControl
                            id="minMinuscule"
                            name="minMinuscule"
                            [(ngModel)]="passwordParams.minMinuscule"
                            customType="number"
                            [required]="true"
                            min="1"
                            libelle="admin.parametres.authentification.generalites.nombreMinuscules"
                            [suffix]="'admin.parametres.authentification.generalites.nombreMinusculesSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.nombreMinusculesTooltip' | translate"
                    ></custom-input>
                    <!--Nombre de symboles-->
                    <custom-input
                            ngDefaultControl
                            id="minSpecial"
                            name="minSpecial"
                            [(ngModel)]="passwordParams.minSpecial"
                            customType="number"
                            [required]="true"
                            min="1"
                            libelle="admin.parametres.authentification.generalites.symboles"
                            [suffix]="'admin.parametres.authentification.generalites.symbolesSuffixe'| translate"
                            [postTooltip]="'admin.parametres.authentification.generalites.symbolesTooltip' | translate"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="passwordParamsService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>